import { Fancybox } from "@fancyapps/ui";

(function (Drupal) {
    Drupal.behaviors.externalImageGallery = {
        attach: function (context, settings) {
            once("callisto-external-image-gallery", ".callisto-external-image-gallery", context).forEach((element) => {
                
                Fancybox.bind(element, "[data-fancybox]", {
                    caption: (fancybox, slide) => {
                        const caption = slide.caption || "";
                        const credits = slide.credits || "";
                        return `
                            <span class="external-caption">${caption}</span>
                            <br />
                            <span class="external-credits">${credits}</span>
                        `;
                    },
                    mainClass: "fancybox-external-image-gallery",
                });

            });
        },
    };
})(Drupal);
